import React from 'react';
import { Check } from 'lucide-react';
import Reveal from '../../../components/shared/Reveal';
import { EditableText } from '../../components';
import { getIcon } from '../iconMap';

function AdmissionCriteria({ data, onChange }) {
  const update = (patch) => onChange && onChange({ ...data, ...patch });
  const c = data.criteria || {};
  const m = data.points_matrix || {};
  const CI = getIcon(c.icon);
  const updateC = (patch) => update({ criteria: { ...c, ...patch } });
  const updateM = (patch) => update({ points_matrix: { ...m, ...patch } });
  const cItems = c.items || [];
  const updateCItem = (i, t) => {
    const next = [...cItems];
    next[i] = t;
    updateC({ items: next });
  };
  const rows = m.rows || [];
  const updateRow = (i, patch) => {
    const next = rows.map((r, idx) => (idx === i ? { ...r, ...patch } : r));
    updateM({ rows: next });
  };
  return (
    <section className="py-24 bg-olive-light">
      <div className="container-page grid lg:grid-cols-2 gap-8">
        <Reveal>
          <div className="card-surface p-8 h-full border-l-4 border-accent">
            <div className="flex items-center gap-3">
              <CI className="text-accent" size={28} />
              <EditableText value={c.title} onChange={(t) => updateC({ title: t })} as="h3" className="font-display text-2xl" />
            </div>
            <ul className="mt-5 space-y-3 text-sm text-ink/75 leading-relaxed">
              {cItems.map((n, i) => (
                <li key={i} className="flex gap-3"><Check size={16} className="text-olive shrink-0 mt-1" /><EditableText value={n} onChange={(t) => updateCItem(i, t)} as="span" /></li>
              ))}
            </ul>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="card-surface p-8 h-full">
            <EditableText value={m.title} onChange={(t) => updateM({ title: t })} as="h3" className="font-display text-2xl" />
            <div className="mt-5 overflow-hidden rounded-2xl border border-olive/10">
              <table className="w-full text-sm">
                <thead className="bg-olive-deep text-white text-xs uppercase tracking-wider">
                  <tr><th className="text-left px-4 py-3">#</th><th className="text-left px-4 py-3">Particulars</th><th className="text-right px-4 py-3">Points</th></tr>
                </thead>
                <tbody>
                  {rows.map((row, i) => (
                    <tr key={i} className="border-t border-olive/10 hover:bg-olive-light/40">
                      <td className="px-4 py-3">{i + 1}.</td>
                      <td className="px-4 py-3"><EditableText value={row.label} onChange={(t) => updateRow(i, { label: t })} as="span" /></td>
                      <td className="px-4 py-3 text-right font-semibold text-olive-deep"><EditableText value={row.points} onChange={(t) => updateRow(i, { points: t })} as="span" /></td>
                    </tr>
                  ))}
                  <tr className="border-t border-olive/10 bg-olive-light/60">
                    <td className="px-4 py-3" />
                    <td className="px-4 py-3 font-semibold"><EditableText value={m.total_label || 'Total'} onChange={(t) => updateM({ total_label: t })} as="span" /></td>
                    <td className="px-4 py-3 text-right font-bold text-accent"><EditableText value={m.total_points} onChange={(t) => updateM({ total_points: t })} as="span" /></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default AdmissionCriteria;
